import type {ConfigAbr} from '../../Config/Models/ConfigAbr';
import {BufferHealthStatus} from '../Constants/BufferHealthStatus';

const bufferHealthStatusMachine = (
    prevBufferHealthStatus: BufferHealthStatus,
    combinedBufferDuration: number,
    configAbr: ConfigAbr
): BufferHealthStatus => {
    const {unhealthyBufferThreshold, healthyBufferThreshold, criticalBufferThreshold} = configAbr;

    switch (prevBufferHealthStatus) {
        case BufferHealthStatus.EMPTY:
            if (combinedBufferDuration >= healthyBufferThreshold) {
                return BufferHealthStatus.HEALTHY;
            } else if (combinedBufferDuration >= unhealthyBufferThreshold) {
                return BufferHealthStatus.UNHEALTHY;
            } else if (combinedBufferDuration >= 0) {
                return BufferHealthStatus.CRITICAL;
            }

            return prevBufferHealthStatus;
        case BufferHealthStatus.CRITICAL:
            if (combinedBufferDuration >= healthyBufferThreshold) {
                return BufferHealthStatus.HEALTHY;
            } else if (combinedBufferDuration >= unhealthyBufferThreshold) {
                return BufferHealthStatus.UNHEALTHY;
            } else if (combinedBufferDuration === 0) {
                return BufferHealthStatus.EMPTY;
            }

            return prevBufferHealthStatus;

        case BufferHealthStatus.HEALTHY:
            if (combinedBufferDuration === 0) {
                return BufferHealthStatus.EMPTY;
            } else if (combinedBufferDuration < criticalBufferThreshold) {
                return BufferHealthStatus.CRITICAL;
            } else if (combinedBufferDuration < unhealthyBufferThreshold) {
                return BufferHealthStatus.UNHEALTHY;
            }

            return prevBufferHealthStatus;
        case BufferHealthStatus.UNHEALTHY:
            if (combinedBufferDuration >= healthyBufferThreshold) {
                return BufferHealthStatus.HEALTHY;
            } else if (combinedBufferDuration === 0) {
                return BufferHealthStatus.EMPTY;
            } else if (combinedBufferDuration < criticalBufferThreshold) {
                return BufferHealthStatus.CRITICAL;
            }

            return prevBufferHealthStatus;
        default:
            return prevBufferHealthStatus;
    }
};

export {bufferHealthStatusMachine};
